<template>
  <!-- About view start -->
  <section id="servicesView" class="px-12 lg:px-32 py-56 mb-8 border-t border-stone-500 relative text-justify">
    <!-- Main text start -->
    <div class="flex-1">
      <h1 class="uppercase text-5xl xl:text-7xl mb-4 justify-left services-title">
        {{ $t("services.our") }}
        <span class="companyName"><strong>{{ $t("services.ourServices") }}</strong></span>
      </h1>
      <br />
      <p class="xl:w-2/2 text-stone-500 mb-8 services-text">
        {{ $t("services.offer") }}{{ $t("services.specialization") }}
      </p>
    </div>
    <br />
    <!-- Main text end -->

    <!-- Circle start -->
    <div class="bg-neutral-200 h-44 w-44 md:h-52 md:w-52 rounded-full absolute top-0 -left-20 mt-16 -z-20 opacity-20">
    </div>
    <!-- Circle end -->

    <!-- Service 1 section start-->
    <v-card variant="outlined" class="service-card">
      <div class="flex flex-col md:flex-row items-center md:items-center gap-8 card-content">
        <!-- Imagen a la izquierda -->
        <img src="@/assets/services/inmigration.svg" alt="immigration" class="md:w-1/5 h-auto md:h-64 card-image" />
        <!-- Contenedor de texto a la derecha -->
        <div class="flex flex-col gap-4 md:w-2/3 text-justify">
          <!-- Título -->
          <h2 class="text-2xl font-semibold text-left services-title">
            {{ $t("services.services[0].name") }}*
          </h2>
          <!-- Párrafos -->
          <div class="flex flex-col gap-4 services-text">
            <p>
              {{ $t("services.services[0].description") }}
            </p>
            <p class="content-text">{{ $t("services.services[0].content") }}</p>
          </div>
          <br />
          <!-- extension start -->
          <div class="flex flex-col md:flex-row md:gap-4">
            <v-container>
              <v-row>
                <v-col cols="12" md="4" xs="6" sm="6">
                  <!-- Wedding service start -->
                  <!-- Imagen e h3 -->
                  <div class="flex flex-row items-center gap-4 md:w-2/3 div-titulo">
                    <img src="@/assets/services/engagement-rings.svg" alt="Wedding"
                      class="w-16 h-16 md:w-20 md:h-20 object-contain" />
                    <h3 class="text-left services-subtitle">
                      {{ $t("services.marriage") }}
                    </h3>

                  </div>
                  <!-- Párrafo Wedding service-->
                  <div class="flex flex-col gap-4 services-text w-full text-description">
                    <p class="text-stone-500 text-justify">
                      {{ $t("services.marriageOffer") }}
                    </p>
                  </div>
                  <!-- Wedding service end -->
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4">
                  <!-- Asylum start -->
                  <!-- Imagen e h3 -->
                  <div class="flex flex-row items-center gap-4 w-full md:w-2/3 div-titulo">
                    <img src="@/assets/services/asylum.svg" alt="Asylum"
                      class="w-16 h-16 md:w-20 md:h-20 object-contain" />
                    <h3 class="text-left services-subtitle">
                      {{ $t("services.asylum") }}
                    </h3>
                  </div>
                  <div>
                    <!-- Párrafo Asylum-->
                    <div class="flex flex-col gap-4 services-text w-full text-description">
                      <p class="text-stone-500 text-justify">
                        {{ $t("services.asylumOffer") }}
                      </p>
                    </div>
                    <!-- Asylum end -->
                  </div>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4">
                  <!-- travel-permit start -->
                  <!-- Imagen e h3 -->
                  <div class="flex flex-row items-center gap-4 w-full md:w-2/3 div-titulo">
                    <img src="@/assets/services/travel-permit.svg" alt="travel-permit"
                      class="w-16 h-16 md:w-20 md:h-20 object-contain" />
                    <h3 class="text-left services-subtitle">
                      {{ $t("services.work") }}
                    </h3>
                  </div>
                  <!-- Párrafo travel-permit -->
                  <div class="flex flex-col gap-4 services-text w-full text-description">
                    <p class="text-stone-500 text-justify">
                      {{ $t("services.workOffer") }}
                    </p>
                  </div>
                  <!-- travel-permit end -->
                </v-col>
              </v-row>
            </v-container>
          </div>
          <!-- extension end -->
          <!-- Availability start -->
          <div class="availability">
            {{ $t("services.availability") }}
            {{
              $t("services.servicesSelector.availableStates.americanTerritory")
            }}.
          </div>
          <!-- Availability end -->
        </div>
      </div>
    </v-card>
    <!-- Service 1 section end-->

    <br />

    <!-- Service 2(new: translations and interpretation) section start-->
    <v-card variant="outlined" class="service-card">
      <div class="flex flex-col md:flex-row items-center md:items-center gap-8 card-content">
        <!-- Imagen a la izquierda -->
        <img src="@/assets/services/translation&interpretation.svg" alt="immigration"
          class="md:w-1/5 h-auto md:h-64 card-image" />
        <!-- Contenedor de texto a la derecha -->
        <div class="flex flex-col gap-4 md:w-2/3 text-justify">
          <!-- Título -->
          <h2 class="text-2xl font-semibold text-left services-title">
            {{ $t("services.services[9].long-name") }}*
          </h2>
          <!-- Párrafos -->
          <div class="flex flex-col gap-4 services-text">
            <p>
              {{ $t("services.services[9].presentation") }}
            </p>
            <h3 class="services-subtitle">
              {{ $t("services.services[9].why") }}
            </h3>
            <p class="content-text">{{ $t("services.services[9].why-list") }}</p>
          </div>
          <!-- extension start -->
          <div class="flex flex-col md:flex-row md:gap-4">
            <v-container>
              <!--<v-row>-->

              <!-- SUBSECCIÓN TRANSLATION service-->

              <!-- Imagen e h3 -->
              <div class="flex flex-row items-center gap-4 div-titulo">
                <img src="@/assets/services/translation.png" alt="translation"
                  class="w-16 h-16 md:w-20 md:h-20 object-contain" />
                <h2 class="services-subtitle">
                  {{ $t("services.services[9].translate") }}
                </h2>
              </div>
              <br>
              <div class="text-description">
                <p class="content-text">
                  {{ $t("services.services[9].translate-presentation") }}
                </p>
              </div>
              <div class="accordion">
                <!--h3 + Párrafo-->
                <div class="div-titulo accordion-item">
                  <input type="checkbox" id="faq1" class="accordion-checkbox">
                  <label for="faq1" class="accordion-header">
                    <h3 class="services-subtitle">
                      {{ $t("services.services[9].translate-mean") }}
                    </h3>
                    <span class="plus-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                        fill="#132e63">
                        <path
                          d="m480-360 160-160H320l160 160Zm0 280q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                      </svg>
                    </span>
                  </label>
                  <div class="accordion-body">
                    <p class="content-text">
                      {{ $t("services.services[9].translate-explained") }}
                    </p>
                    <p class="content-text">
                      {{ $t("services.services[9].translate-mean-conclution") }}
                    </p>
                  </div>
                </div>
                <!--h3 + Párrafo-->
                <div class="div-titulo accordion-item">
                  <input type="checkbox" id="faq2" class="accordion-checkbox">
                  <label for="faq2" class="accordion-header">
                    <h3 class="services-subtitle">
                      {{ $t("services.services[9].whatTranslate") }}
                    </h3>
                    <span class="plus-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                        fill="#132e63">
                        <path
                          d="m480-360 160-160H320l160 160Zm0 280q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                      </svg>
                    </span>
                  </label>
                  <div class="accordion-body">
                    <p class="content-text">
                      {{ $t("services.services[9].whatTranslate-list") }}
                    </p>
                    <p class="content-text">
                      {{ $t("services.services[9].translate-afirmation") }}
                    </p>
                    <br>
                  </div>
                </div>
                <!--h3 + Párrafo-->
                <div class="div-titulo accordion-item">
                  <input type="checkbox" id="faq3" class="accordion-checkbox">
                  <label for="faq3" class="accordion-header">
                    <h3 class="services-subtitle">
                      {{ $t("services.services[9].translate-include") }}
                    </h3>
                    <span class="plus-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                        fill="#132e63">
                        <path
                          d="m480-360 160-160H320l160 160Zm0 280q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                      </svg>
                    </span>
                  </label>
                  <div class="accordion-body">
                    <p class="content-text">
                      {{ $t("services.services[9].translate-include-list") }}
                    </p>
                    <p class="content-text">
                      {{ $t("services.services[9].CFRafirmation") }}
                    </p>
                  </div>
                </div>
                <!--h3 + Párrafo-->
                <div class="div-titulo accordion-item">
                  <input type="checkbox" id="faq4" class="accordion-checkbox">
                  <label for="faq4" class="accordion-header">
                    <h3 class="services-subtitle">
                      {{ $t("services.services[9].howTranslate") }}
                    </h3>
                    <span class="plus-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                        fill="#132e63">
                        <path
                          d="m480-360 160-160H320l160 160Zm0 280q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                      </svg>
                    </span>
                  </label>
                  <div class="accordion-body">
                    <p class="content-text">
                      {{ $t("services.services[9].howTranslate-steps") }}
                    </p>
                  </div>
                </div>
              </div>
              <br>
              <p class="content-text">
                {{ $t("services.services[9].translateCall") }}
              </p>

              <!-- SUBSECCIÓN TRANSLATION service end -->
              <br>
              <!-- SUBSECCIÓN INTERPRETATION service-->

              <!-- Imagen e h3 -->
              <div class="flex flex-row items-center gap-4 div-titulo">
                <img src="@/assets/services/interpretation.png" alt="interpretation"
                  class="w-16 h-16 md:w-20 md:h-20 object-contain" />
                <h2 class="services-subtitle">
                  {{ $t("services.services[9].interpretation") }}
                </h2>
              </div>
              <br>
              <div class="text-description">
                <!--<h3 class="services-subtitle">
                  {{ $t("services.services[9].interpretationIncludes") }}
                </h3>-->
                <p class="content-text">
                  {{ $t("services.services[9].interpretationIncludes-list") }}
                </p>
              </div>
              <br>
              <!--h3 + Párrafo-->
              <div class="div-titulo accordion-item">
                <input type="checkbox" id="faq5" class="accordion-checkbox">
                <label for="faq5" class="accordion-header">
                  <h3 class="services-subtitle">
                    {{ $t("services.services[9].howInterpretation") }}
                  </h3>
                  <span class="plus-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                      fill="#132e63">
                      <path
                        d="m480-360 160-160H320l160 160Zm0 280q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                    </svg>
                  </span>
                </label>
                <div class="accordion-body">
                  <p class="content-text">
                    {{ $t("services.services[9].howInterpretation-steps") }}
                  </p>
                </div>
              </div>
              <br>
              <p class="content-text">
                {{ $t("services.services[9].interpretationCall") }}
              </p>
              <!-- SUBSECCIÓN INTERPRETATION service END-->

              <!--</v-row>-->
            </v-container>
          </div>
          <!-- extension end -->

          <!-- Availability start -->
          <div class="availability">
            {{ $t("services.availability") }}
            {{
              $t("services.servicesSelector.availableStates.americanTerritory")
            }}.
          </div>
          <!-- Availability end -->
        </div>
      </div>
    </v-card>
    <!-- Service 2 (new: translations and interpretation) section end-->

    <br />
    <!-- Service 3 section start-->
    <v-card variant="outlined" class="service-card">
      <div class="flex flex-col md:flex-row items-center md:items-center gap-8 card-content">
        <!-- Imagen a la izquierda -->
        <img src="@/assets/services/home.svg" alt="home" class="md:w-1/5 h-auto md:h-64 object-contain card-image" />
        <!-- Contenedor de texto a la derecha -->
        <div class="flex flex-col gap-4 md:w-2/3 text-justify">
          <!-- Título -->
          <h2 class="text-2xl font-semibold text-left services-title">
            {{ $t("services.services[2].name") }}*
          </h2>
          <!-- Párrafos -->
          <div class="flex flex-col gap-4 services-text">
            <p>
              {{ $t("services.services[2].description") }}
            </p>
            <p class="content-text">{{ $t("services.services[2].content") }}</p>
          </div>
          <!-- Availability start -->
          <div class="availability">
            {{ $t("services.availability") }} Florida.
          </div>
          <!-- Availability end -->
        </div>
      </div>
    </v-card>
    <!-- Service 3 section end-->

    <br />
    <!-- Service 4 section start-->
    <v-card variant="outlined" class="service-card">
      <div class="flex flex-col md:flex-row items-center md:items-center gap-8 card-content">
        <!-- Imagen a la izquierda -->
        <img src="@/assets/services/home-credit.svg" alt="home-credit"
          class="w-full md:w-1/5 h-auto md:h-64 object-contain card-image" />
        <!-- Contenedor de texto a la derecha -->
        <div class="flex flex-col gap-4 md:w-2/3 text-justify">
          <!-- Título -->
          <h2 class="text-2xl font-semibold text-left services-title">
            {{ $t("services.services[3].name") }}*
          </h2>
          <!-- Párrafos -->
          <div class="flex flex-col gap-4 services-text">
            <p>
              {{ $t("services.services[3].description") }}
            </p>
            <p class="content-text">{{ $t("services.services[3].content") }}</p>
          </div>
          <!-- Availability start -->
          <div class="availability">
            {{ $t("services.availability") }} Florida, Texas, California.
          </div>
          <!-- Availability end -->
        </div>
      </div>
    </v-card>
    <!-- Service 4 section end-->

    <br />
    <!-- Service 5 section start-->
    <v-card variant="outlined" class="service-card">
      <div class="flex flex-col md:flex-row items-center md:items-center gap-8 card-content">
        <!-- Imagen a la izquierda -->
        <img src="@/assets/services/car.svg" alt="car"
          class="w-full md:w-1/5 h-auto md:h-64 object-contain card-image" />
        <!-- Contenedor de texto a la derecha -->
        <div class="flex flex-col gap-4 md:w-2/3 text-justify">
          <!-- Título -->
          <h2 class="text-2xl font-semibold text-left services-title">
            {{ $t("services.services[4].name") }}*
          </h2>
          <!-- Párrafos -->
          <div class="flex flex-col gap-4 services-text">
            <p>
              {{ $t("services.services[4].description") }}
            </p>
            <p class="content-text">{{ $t("services.services[4].content") }}</p>
          </div>
          <!-- Availability start -->
          <div class="availability">
            {{ $t("services.availability") }} Florida, Utah.
          </div>
          <!-- Availability end -->
        </div>
      </div>
    </v-card>
    <!-- Service 5 section end-->
    <br />
    <!-- Service 6 section start-->
    <v-card variant="outlined" class="service-card">
      <div class="flex flex-col md:flex-row items-center md:items-center gap-8 card-content">
        <!-- Imagen a la izquierda -->
        <img src="@/assets/services/insurance.svg" alt="insurance"
          class="w-full md:w-1/5 h-auto md:h-64 object-contain card-image" />
        <!-- Contenedor de texto a la derecha -->
        <div class="flex flex-col gap-4 md:w-2/3 text-justify">
          <!-- Título -->
          <h2 class="text-2xl font-semibold text-left services-title">
            {{ $t("services.services[5].name") }}*
          </h2>
          <!-- Párrafos -->
          <div class="flex flex-col gap-4 services-text">
            <p>
              {{ $t("services.services[5].description") }}
            </p>
            <p class="content-text">{{ $t("services.services[5].content") }}</p>
          </div>
          <!-- Availability start -->
          <div class="availability">
            {{ $t("services.availability") }} Utah.
          </div>
          <!-- Availability end -->
        </div>
      </div>
    </v-card>
    <!-- Service 6 section end-->

    <br />
    <!-- Service 7 section start-->
    <v-card variant="outlined" class="service-card">
      <div class="flex flex-col md:flex-row items-center md:items-center gap-8 card-content">
        <!-- Imagen a la izquierda -->
        <img src="@/assets/services/taxes.svg" alt="taxes"
          class="w-full md:w-1/5 h-auto md:h-64 object-contain card-image" />
        <!-- Contenedor de texto a la derecha -->
        <div class="flex flex-col gap-4 md:w-2/3 text-justify">
          <!-- Título -->
          <h2 class="text-2xl font-semibold text-left services-title">
            {{ $t("services.services[6].name") }}*
          </h2>
          <!-- Párrafos -->
          <div class="flex flex-col gap-4 services-text">
            <p>
              {{ $t("services.services[6].description") }}
            </p>
            <p class="content-text">{{ $t("services.services[6].content") }}</p>
          </div>
          <!-- Availability start -->
          <div class="availability">
            {{ $t("services.availability") }}
            {{
              $t("services.servicesSelector.availableStates.americanTerritory")
            }}.
          </div>
          <!-- Availability end -->
        </div>
      </div>
    </v-card>
    <!-- Service 7 section end-->

    <br />
    <!-- Service 8 section start-->
    <v-card variant="outlined" class="service-card">
      <div class="flex flex-col md:flex-row items-center md:items-center gap-8 card-content">
        <!-- Imagen a la izquierda -->
        <img src="@/assets/services/coach.svg" alt="coach"
          class="w-full md:w-1/5 h-auto md:h-64 object-contain card-image" />
        <!-- Contenedor de texto a la derecha -->
        <div class="flex flex-col gap-4 md:w-2/3 text-justify">
          <!-- Título -->
          <h2 class="text-2xl font-semibold text-left services-title">
            {{ $t("services.services[7].name") }}*
          </h2>
          <!-- Párrafos -->
          <div class="flex flex-col gap-4 services-text">
            <p>
              {{ $t("services.services[7].description") }}
            </p>
            <p class="content-text">{{ $t("services.services[7].content") }}</p>
          </div>
          <!-- Availability start -->
          <div class="availability">
            {{ $t("services.availability") }}
            {{
              $t("services.servicesSelector.availableStates.americanTerritory")
            }}.
          </div>
          <!-- Availability end -->
        </div>
      </div>
    </v-card>
    <!-- Service 8 section end-->
  </section>

  <!-- Contact section start -->
  <contact-section></contact-section>
  <!-- Contact section end -->

  <!-- WhatsApp Floating Icon start -->
  <a :href="'https://wa.me/' + wppNumber" class="whatsapp-float" target="_blank">
    <i class="fab fa-whatsapp"></i>
  </a>
  <!-- WhatsApp Floating Icon end -->
</template>

<script>
import ContactSection from "@/sections/ContactSection.vue";
export default {
  components: {
    ContactSection,
  },
  data() {
    return {
      wppNumber: "17864138919",
    };
  },
};
</script>

<style scoped>
.services-title {
  color: #132e63;
}


.services-text {
  color: #051328 !important;
}

.service-card {
  margin: 1rem 1rem 1rem 1rem !important;
  border: 0.5px solid #132e63;
  border-radius: 0.5rem;
}

.div-titulo {
  width: 100%;
  margin-bottom: 0% !important;
}

.card-image {
  /*width: 20% !important;*/
  height: 10%;
}

.card-content {
  padding: 2rem 2rem 2rem 2rem !important;
}

.services-subtitle {
  color: #132e63 !important;
  font-size: 1rem;
  width: fit-content;
  overflow:visible;
}

.availability {
  color: #132e63 !important;
}

/*.text-description {
  margin-top: 1rem;
  padding-top: 0px;

}*/

.content-text {
  white-space: pre-line;
}

.service-image {
  align-items: center;
  /* Centra verticalmente */
  width: 30%;
  height: auto;
  border-radius: 0.5rem;
}

.whatsapp-float {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  right: 40px;
  background-color: #25d366;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  box-shadow: 2px 2px 3px #999;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.whatsapp-float i {
  font-size: 30px;
}

/* Estilos del Acordeón */
.accordion {
  width: 100%;
  margin-top: 20px;
  gap: 10px;
}

/* REVISAR */
.accordion-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 10px;
}

.accordion-checkbox {
  display: none;
  /* Oculta el checkbox */
}

.accordion-header {
  display: flex;
  justify-content: flex-start;
  gap: 15px;
  align-items: center;
  padding: 0;
  cursor: pointer;
  transition: color 0.3s ease;
}

/* REVISAR */
.accordion-header:hover {
  color: var(--primary-color);
}

.plus-icon {
  font-size: 24px;
  font-weight: 400;
  color: var(--primary-color);
  /* REVISAR */
  transition: transform 0.3s ease;
}

/* Estilo para cuando el acordeón está abierto */
.accordion-checkbox:checked+.accordion-header .plus-icon {
  /* Transforma el '+' en una línea horizontal, simulando el ícono de cierre */
  transform: rotate(180deg);
}

.accordion-body {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out, padding 0.3s ease;
}

.accordion-checkbox:checked~.accordion-body {
  max-height: 800px;
  /* Suficiente altura para el contenido */
  padding-bottom: 20px;
}

.accordion-body p {
  font-size: 15px;
  color: var(--text-grey);
  /* REVISAR */
}
</style>
